import { AnimatePresence, motion } from 'framer-motion'
import { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { IoChevronForwardOutline as TbChevronsRight } from 'react-icons/io5'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import styled from 'styled-components'
import Nav from './components/Nav'
import SuccessiveType from './components/SuccessiveType'
import Error from './pages/Error.jsx'
import Home from './pages/Home'
import More from './pages/More.jsx'
import Projects from './pages/Projects.jsx'
import Skills from './pages/Skills.jsx'

const shouldPlayIntro = window.location.pathname === '/'

function App() {
  const [introEnded, setIntroEnded] = useState(!shouldPlayIntro)

  const onKeyDown = (e) => {
    if ((e.keyCode === 9 || e.which === 9) && !introEnded) {
      e.preventDefault()
    }
  }

  useEffect(() => {
    if (!shouldPlayIntro) {
      return
    }
    import('./effects/stars.js')
    // eslint-disable-next-line react-web-api/no-leaked-event-listener
    document.addEventListener('keydown', onKeyDown)
  }, [])

  const onIntroEnd = useCallback(() => {
    localStorage.setItem('v1:intro-completed', 'true')
    setIntroEnded(true)
  }, [])

  return (
    <Wrapper>
      <Helmet
        titleTemplate="%s • Ruhan"
        defaultTitle="Ruhan Rouf"
      >
        <title>Ruhan Rouf</title>
      </Helmet>
      {shouldPlayIntro
        ? (
            <SuccessiveTypeContainer
              transition={{ duration: 0.85 }}
              animate={{ y: introEnded ? -window.innerHeight : 0 }}
            >
              <ProgressContainer onClick={onIntroEnd}>
                <h4>
                  Skip intro
                  {' '}
                  <TbChevronsRight />
                </h4>
              </ProgressContainer>
              <SuccessiveType
                onEnd={onIntroEnd}
                words="Building websites is like creating magic on the internet! I make websites that are simple, easy to use, and work super fast."
                speed={1}
                userSkipped={introEnded}
              />
            </SuccessiveTypeContainer>
          )
        : null}

      <motion.canvas
        transition={{ duration: 0.85 }}
        animate={{ opacity: introEnded ? 0 : 0.25 }}
        id="stars"
      />

      <MainContent
        transition={{ duration: 0.85 }}
        initial={false}
        animate={{ y: !introEnded ? window.innerHeight : 0 }}
      >
        <Router>
          <Nav />
          <ContentWrapper>
            <AnimatePresence>
              {/* <Suspense fallback={null}> */}
              <Routes>
                <Route
                  index
                  element={<Home />}
                />
                <Route
                  path="/projects"
                  element={<Projects />}
                />
                <Route
                  path="/skills"
                  element={<Skills />}
                />
                <Route
                  path="/more"
                  element={<More />}
                />
                <Route
                  path="*"
                  element={<Error />}
                />
              </Routes>
              {/* </Suspense> */}
            </AnimatePresence>
          </ContentWrapper>
        </Router>
      </MainContent>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  canvas {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 0;
    opacity: 0.5;
  }
`

const SuccessiveTypeContainer = styled(motion.div)`
  width: 65ch;
  height: 350px;
  padding: 2rem;
  position: relative;
  z-index: 1;
`

const ProgressContainer = styled.div`
  vertical-align: middle;
  cursor: pointer;
  transition: color 0.2s ease;

  svg {
    vertical-align: middle;
    height: 19px;
  }

  &:hover {
    color: #3c71e4;
  }
`

const MainContent = styled(motion.div)`
  height: 100vh;
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: row;
  overflow-y: auto;
  @media (max-width: 850px) {
    flex-direction: column;
    /* padding-top: 65px; */
  }
`

const ContentWrapper = styled.div`
  margin-left: 15rem;
  padding: 2rem;
  width: 100%;
  box-sizing: border-box;
  font-size: 1rem;
  a {
    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: 850px) {
    margin-left: 0px;
    padding-top: 65px;
  }
`

export default App
